import React from 'react';
import { useEffect, createRef } from 'react';
import { Modal, ModalHeader, ModalBody, Row, Col, Input, Label, Button, FormGroup } from 'reactstrap';
import Select from 'react-select';
import { FormContainer, ToolBox } from 'zubair-react-form-builder';
import $ from 'jquery';

const CAFFormModal = props => {
  const {
    isOpen,
    toggleModal,
    mode,
    save,
    handle,
    setHandle,
    name,
    setName,
    description,
    setDescription,
    isDefault,
    setIsDefault,
    hasSite,
    setHasSite,
    propagateAddress,
    setPropagateAddress,
    cafSectionId,
    setCafSectionId,
    cafSections,
    template
  } = props;

  useEffect(() => {
    if (!isOpen) return;

    function initForm() {
      // Update form builder
      $('.toolbox.ui-droppable .card-header span.pull-left').text('Form Fields');
      $('.toolbox.ui-droppable.toolbox .btn:contains("Save")').hide();
      $('[data-target="#previewModal"]').hide();
      $('[data-tool="DURATION_PICKER"]').hide();

      // Update preview modal
      $('#previewModal .modal-header button').hide();
      $('#previewModal .modal-footer').hide();
      $('#exampleModalLabel').text('Preview Form');

      // Initialise existing fields
      $('.list-group.ui-sortable').children().each(function () {
        initFormField(this);
      });
    }

    function initFormField(field) {
      const $field = $(field);

      $field.find('.nav-tabs').each(function () {
        const navTabs = $(this);
        activateTab(navTabs, 0);
        navTabs.on('click', 'a', function () {
          activateTab(navTabs, $(this).parent().index());
        });
      });

      $field.find('.general .alert').hide();

      var allowedOptions = ['Text', 'Textarea', 'Email', 'Date'];
      $field.find('select').find('option').each(function () {
        if (!allowedOptions.includes($(this).val())) $(this).hide();
      });
    }

    function activateTab(navTabs, tabIndex) {
      const panels = navTabs.nextAll();
      const targetPanel = panels.eq(tabIndex);

      navTabs.find('a').removeClass('active');
      navTabs.find('a').eq(tabIndex).addClass('active');

      panels.attr('hidden', '').removeClass('d-block');
      targetPanel.removeAttr('hidden').addClass('d-block');
    }

    const initFormTimeoutId = setTimeout(initForm, 500);

    // Initialise new fields
    let observer;
    const observerTimeoutId = setTimeout(() => {
      const sortable = document.querySelector('.list-group.ui-sortable');
      if (sortable) {
        observer = new MutationObserver((mutations) => {
          mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
              if (node.nodeType === 1) initFormField(node);
            });
          });
        });
        observer.observe(sortable, { childList: true });
      }
    }, 1000);

    return () => {
      clearTimeout(initFormTimeoutId);
      clearTimeout(observerTimeoutId);
      if (observer) observer.disconnect();
    };
  }, [isOpen]);

  const openPreviewModal = () => {
    const previewModal = document.querySelector('#previewModal');
    previewModal && previewModal.classList.add('show', 'd-block');
  };

  const closePreviewModal = (e) => {
    const previewModal = document.querySelector('#previewModal');
    if (!previewModal || !previewModal.classList.contains('show')) return;
    const modalContent = previewModal.querySelector('.modal-content');
    if (modalContent && !modalContent.contains(e.target)) {
      previewModal.classList.remove('show', 'd-block');
    }
  };

  useEffect(() => {
    document.body.addEventListener('click', closePreviewModal);
    return () => {
      document.body.removeEventListener('click', closePreviewModal);
    };
  }, []);

  const updateForm = (callback) => {
    if (template) {
      let rawForm = template && template.Form;
      let form = JSON.parse(rawForm);
      callback(form);
    }
  };

  // This ref is used to apply the functionality of the hidden save button within
  // the FormContainer component to a save button outside the component
  const formRef = createRef();

  const sectionOptions = (cafSections || []).map(s => ({
    label: s.Name,
    value: s.CAFSectionId,
  }));

  return (
    <Modal size="xl" isOpen={isOpen} toggle={toggleModal} onOpened={() => { const el = document.querySelector('.modal'); if (el) el.scrollTop = 0; }}>
      <ModalHeader toggle={toggleModal}>{mode === 'edit' ? 'Edit CAF Template' : 'Create New CAF Template'}</ModalHeader>
      <ModalBody>
        {isOpen &&
          <Row>
            <Col sm={9} className="text-right">
              <Button color="primary" className="mr-2" onClick={() => openPreviewModal()}>Preview Template</Button>
              <Button color="success" onClick={() => formRef.current.popForm()}>Save Template</Button>
            </Col>
            <Col sm={9}>
              <Label>Handle <small className="text-danger">*</small></Label>
              <Input
                type="text"
                className="mb-3"
                value={handle}
                onChange={e => setHandle(e.target.value)}
              />
              <Label>Name <small className="text-danger">*</small></Label>
              <Input
                type="text"
                className="mb-3"
                value={name}
                onChange={e => setName(e.target.value)}
              />
              <Label>Description</Label>
              <Input
                type="textarea"
                className="mb-3"
                value={description || ''}
                onChange={e => setDescription(e.target.value)}
              />
              <Label>CAF Section</Label>
              <Select
                className="mb-3"
                options={sectionOptions}
                value={sectionOptions.find(o => o.value === cafSectionId) || null}
                onChange={opt => setCafSectionId(opt ? opt.value : null)}
                isClearable
                placeholder="Any section"
              />
              {cafSectionId && (
                <FormGroup check className="mb-3">
                  <Label check>
                    <Input
                      type="checkbox"
                      checked={isDefault || false}
                      onChange={e => setIsDefault(e.target.checked)}
                    />
                    <span>Included by default</span>
                  </Label>
                </FormGroup>
              )}
              <FormGroup check className="mb-3">
                <Label check>
                  <Input
                    type="checkbox"
                    checked={hasSite || false}
                    onChange={e => setHasSite(e.target.checked)}
                  />
                  <span>Associated with site</span>
                </Label>
              </FormGroup>
              {hasSite && (
                <FormGroup check className="mb-3">
                  <Label check>
                    <Input
                      type="checkbox"
                      checked={propagateAddress || false}
                      onChange={e => setPropagateAddress(e.target.checked)}
                    />
                    <span>Propagate address during pre-fill</span>
                  </Label>
                </FormGroup>
              )}
              <Label>Template Form</Label>
              <FormContainer
                ref={formRef}
                onSave={save}
                updateForm={updateForm}
                updateOnMount={true}
              />
            </Col>
            <Col sm={3}>
              <ToolBox />
            </Col>
          </Row>
        }
      </ModalBody>
    </Modal>
  )
}

export default CAFFormModal;
